import Vue from 'vue'
import VueRouter from 'vue-router'
import $router from '../router'
import { local } from "@/utils/storage.js";

//引入页面文件
import Home from '@/views/home/index.vue'
import NewsList from '@/views/news/newsList.vue'
import NewsDetail from '@/views/news/newsDetail.vue'
import ProfessorDetail from '@/views/professor/detail.vue'
import SearchResult from '@/views/searchPage/searchResult.vue'
import CooperateUnit from '@/views/cooperateUnit/list'

Vue.use(VueRouter)


//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // 首页
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '厦门市大学生创业与产教融合促进会',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '首页'
    },
  },
  //资讯
  {
    path: '/newsList',
    name: 'NewsList',
    component: NewsList,
    meta: {
      title: '新闻中心',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '新闻中心',
    },
    children: [{
      path: 'newsDetail/:id/:categoryId',
      name: 'NewsDetail',
      component: NewsDetail,
      meta: {
        title: '媒体报道',
        content: {
          keywords: '',
          description: ''
        },
        breadcrumb: '媒体报道',
      },
    }],
  },
  {
    path: '/professor/detail/:id',
    component: ProfessorDetail,
    meta: {
      title: '专家顾问',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '专家顾问',
    },

  },
  {
    path: '/searchPage/searchResult',
    name: 'SearchResult',
    component: SearchResult,
    meta: {
      title: '结果列表',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '搜索结果',
    },

  },
  {
    path: '/cooperateUnit/list',
    name: 'CooperateUnit',
    component: CooperateUnit,
    meta: {
      title: '合作单位',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '合作单位',
    },
  },

  // {
  //   path: '*', // 页面不存在的情况下会跳到404页面
  //   redirect: '/404',
  //   name: 'notFound',
  //   hidden: true
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})




//路由变化时执行
router.beforeEach(function (to, from, next) {
  //回到顶部
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;
  //动态修改TDk
  if (to.meta.content) {
    const head = document.getElementsByTagName('head')
    const meta = document.createElement('meta')
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  // 路由发生变化修改页面title
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  document.title = "厦门市大学生创业促进会"
  if (to.matched.length === 0) {
    next({
      // path: "/404",
    })
  }

  //判断移动端
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  if (flag) {
    if (!local.Get("isPc")) {
      local.Set("isPc", true)
      if (to.name == 'Phone') {
        next()
      } else {
        next({
          path: "/phone",
          query: {
            option: to.fullPath
          }
        });
      }
    } else {
      next()
    }
  } else {
    //判断是否需要登录
    if (to.meta.requiresAuth) {
      let scCustom = local.Get("scCustom");
      let isLogin = local.Get("isLogin");
      if (isLogin) {
        next(); //表示已经登录
        if (scCustom.auditStatus == 2) {
          next()
        } else {
          if (to.path.indexOf("personCenter") != -1) {
            next()
            return
          }
          //未认证
          Vue.prototype.$confirm("您尚未认证, 是否前往认证?", "认证提醒", {
            confirmButtonText: "去认证",//确认按钮文字更换
            cancelButtonText: "取消",//取消按钮文字更换
            showClose: true,//是否显示右上角关闭按钮
            type: "warning",
          }).then(res => {
            if (res) {
              next({
                path: "/personCenter/auth",
                query: { redirect: to.path } //登录后再跳回此页面时要做的配置
              });
            }
          }, err => {
            console.log('取消认证', err);
            $router.back()
          })
        }
      } else {
        //未登录
        Vue.prototype.$confirm("您暂未登录, 是否前往登录?", "登录提醒", {
          confirmButtonText: "去登录",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",
        }).then(res => {
          if (res) {
            next({
              path: "/login",
              query: { redirect: to.path } //登录后再跳回此页面时要做的配置
            });
          }
        })
      }
    } else {
      //表示不需要登录
      next(); //继续往后走
    }
  }
})
router.afterEach(function () {
  local.Set('isPc', false)
})











export default router
